import React from 'react'
import {BankBilletHeader} from './BankBilletHeader'
import {InvoiceTable} from './InvoiceTable'
import {parse} from 'qs'
import moment from "../../helpers/moment"
import './BankBillet.css'
import './style-boleto.css'
import FinancialRequests from '../../requests/financial-requests'
import NRTButton from "../_common/_buttons/Button"
import MCLoadingOverlay from '../_minha-central/LoadingOverlay'

class BankBillet extends React.Component {

    state = {
        awaitingGet: true,
        awaitingGenerate: false,
        empInvoiceBankBillet: null,
        systemParameters: this.props.context.systemParams,
        bankBilletStatus: null,
        errorMsg: null
    }

    constructor(props) {
        super(props)
    }

    async componentWillMount() {

        const query = parse(this.props.location.search.substr(1))
        this.prsCode = query.p
        this.ibbCode = this.props.match.params.ibbCode

        await this.getBankBilletFromApi()
    }

    async getBankBilletFromApi() {
        try {
            const empInvoiceBankBillet = await FinancialRequests.getBankBillet(this.ibbCode, this.prsCode)
            console.log(empInvoiceBankBillet, 'IBB Completo')
            if (empInvoiceBankBillet && empInvoiceBankBillet.invoices) {
                this.setState({
                    empInvoiceBankBillet: empInvoiceBankBillet,
                    awaitingGet: false
                })

            } else {
                this.setState({
                    errorMsg: 'Não foi possível encontrar o boleto informado',
                    awaitingGet: false
                })
            }

            this.defineBankBilletStatus()

        } catch (err) {
            if (err.response && err.response.status === 404) {
                this.setState({
                    awaitingGet: false,
                    errorMsg: 'Boleto não encontrado - 404'
                })
            } else {
                this.setState({
                    awaitingGet: false,
                    errorMsg: 'Erro inesperado ao acessar boleto - 500 '
                })
            }
        }
    }


    generateBankBillet = async () => {

        this.setState({
            awaitingGenerate: true
        })

        try {
            const newIbbCode = await FinancialRequests.generateBankBillet(this.ibbCode, this.prsCode)

            console.log(newIbbCode, 'novo IBB')
            if (newIbbCode !== this.ibbCode) {
                this.ibbCode = newIbbCode
                await this.getBankBilletFromApi()
                this.setState({
                    awaitingGenerate: false
                })
            }
        } catch (err) {
            this.setState({
                awaitingGenerate: false
            })
        }
    }

    defineBankBilletStatus() {

        const invoices = this.state.empInvoiceBankBillet.invoices

        // Compara status das faturas
        const totalPaidInvoices = invoices.filter(invoice => invoice.status === 'PAID').length
        if (totalPaidInvoices === invoices.length) {
            this.setState({
                bankBilletStatus: 'PAID'
            })

            return
        }

        // Se nao esta pago, compara datas
        const {empInvoiceBankBillet} = this.state
        const today = moment()
        const daysExpired = today.startOf('day').diff(moment.utc(empInvoiceBankBillet.expirationDate).startOf('day'), 'days')
        if ((today.day() === 0 && daysExpired <= 1) || (today.day() === 1 && daysExpired <= 2)) {
            this.setState({
                bankBilletStatus: 'OK'
            })
        } else if (moment.utc(empInvoiceBankBillet.expirationDate).startOf('day').isSameOrAfter(today.utc().startOf('day'))) {
            this.setState({
                bankBilletStatus: 'OK'
            })
        } else {
            this.setState({
                bankBilletStatus: 'DEFAULTING'
            })
        }

    }

    render() {

        const {
            awaitingGet,
            awaitingGenerate,
            empInvoiceBankBillet,
            systemParameters,
            bankBilletStatus,
            errorMsg
        } = this.state

        const loading = awaitingGet && !empInvoiceBankBillet && errorMsg === null

        if (loading) {
            return (<MCLoadingOverlay show={true}/>)
        }

        if (!systemParameters) {
            return null
        }


        if (errorMsg) {
            return (
                <div className="application-error" data-icon="X">
                    <p>
                        <strong>{errorMsg}</strong>
                    </p>
                </div>
            )
        }


        return (
            <div id={'bankbillet'} className='container'>
                <div className={'bankbillet-inner-content'}>
                    <BankBilletHeader systemParameters={systemParameters}
                                      empInvoiceBankBillet={empInvoiceBankBillet} status={bankBilletStatus}/>

                    <br/>
                    <InvoiceTable invoices={empInvoiceBankBillet.invoices}
                                  totalValue={parseFloat(empInvoiceBankBillet.value)}/>

                    <div className='btnspan'>
                        {bankBilletStatus === 'DEFAULTING' &&
                        <NRTButton
                            className="button-boleto second"
                            onClick={this.generateBankBillet}
                            loading={awaitingGenerate}>
                            <svg height="16" style={{paddingRight: '31px'}} width="16"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 14h12v-3h2v5H1zm0-3h2v3H1zM6 1h4v7h2l-4 5-4-5h2zm0 0" fill="#fff"/>
                            </svg>
                            Gerar Boleto (2ª via)
                        </NRTButton>
                        }

                        {bankBilletStatus === 'OK' &&
                        <a
                            className="button-boleto"
                            href={empInvoiceBankBillet.url}
                            target="_blank">
                            <svg height="16" style={{paddingRight: 25, width: 40}} width="16"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 14h12v-3h2v5H1zm0-3h2v3H1zM6 1h4v7h2l-4 5-4-5h2zm0 0" fill="#fff"/>
                            </svg>
                            Obter Boleto
                        </a>
                        }
                    </div>

                </div>
            </div>
        )
    }
}


export default BankBillet



// WEBPACK FOOTER //
// ./src/components/BankBillet/BankBillet.js